import { writable } from 'svelte/store'

export const accountsStore = items([])
export const chargesStore = items([])
export const errorsStore = items([])
export const creditsStore = items([])
export const facturamaInvoicesStore = items([])
export const fixedpricesStore = items([])
export const foliosStore = items([])
export const invoicesStore = items([])
export const notificationsStore = items([])
export const ordersStore = items([])
export const pickupsStore = items([])
export const prepaidsStore = items([])
export const pricingsStore = items([])
export const tilPricingsStore = items([])
export const providersStore = items([])
export const schemesStore = items([])
export const shipmentsSelectedStore = items([])
export const shipmentsStore = items([])
export const shopifysStore = items([])
export const ticketsStore = items([])
export const tracingsStore = items([])
export const transactionsStore = items([])
export const usersStore = items([])

export const accountStore = writable(null)
export const adminStore = writable(null)
export const errorStore = writable(null)
export const chargeStore = writable(null)
export const creditStore = writable(null)
export const facturamaClientStore = writable(null)
export const fixedpriceStore = writable(null)
export const folioStore = writable(null)
export const invoiceStore = writable(null)
export const notificationStore = writable(null)
export const notifyStore = writable(null)
export const orderStore = writable(null)
export const pickupStore = writable(null)
export const prepaidStore = writable(null)
export const pricingStore = writable(null)
export const tilPricingStore = writable(null)
export const providerStore = writable(null)
export const shipmentStore = writable(null)
export const shopifyStore = writable(null)
export const ticketStore = writable(null)
export const userStore = writable(null)

export const modalStore = $modalStore()
export const eventStore = writable(null)

function $modalStore() {

    const store = writable(null)

    store.close = () => store.set(null)

    store.open = (type, prefix = null, data = null) => {

        if(!prefix && !data)
            return store.set(type)

        type === 'error' && errorStore.set(data)
        type === 'account' && accountStore.set(data)
        type === 'admin' && adminStore.set(data)
        type === 'charge' && chargeStore.set(data)
        type === 'credit' && creditStore.set(data)
        type === 'fixedprice' && fixedpriceStore.set(data)
        type === 'facturamaClient' && facturamaClientStore.set(data)
        type === 'folio' && folioStore.set(data)
        type === 'invoice' && invoiceStore.set(data)
        type === 'notification' && notificationStore.set(data)
        type === 'notify' && notifyStore.set(data)
        type === 'order' && orderStore.set(data)
        type === 'prepaid' && prepaidStore.set(data)
        type === 'pricing' && pricingStore.set(data)
        type === 'tilPricing' && tilPricingStore.set(data)
        type === 'provider' && providerStore.set(data)
        type === 'shipment' && shipmentStore.set(data)
        type === 'ticket' && ticketStore.set(data)
        type === 'user' && userStore.set(data)
        type === 'shopify' && shopifyStore.set(data)
        type === 'pickup' && pickupStore.set(data)

        store.set(`${type}_${prefix}`)
    }

    return store
}

function items(state = null) {
    const {subscribe, update, set} = writable(state)
    return {
        subscribe,
        update,
        set,
        append: item => append(item, update),
        replace: item => replace(item, update),
        remove: itemId => remove(itemId, update)
    }
}

function append(item, update) {
    return update(items => {
        items.unshift(item)
        return items
    })
}

function replace(data, update) {
    return update(items => {
        return items.map(item => {
            return item._id === data._id? data : item
        })
    })
}

function remove(itemId, update) {
    return update(items => {
        return items.filter(item => item._id != itemId)
    })
}